import validate from "/app/node_modules/.pnpm/nuxt@3.17.4_@parcel+watcher@2.5.1_@types+node@22.15.24_better-sqlite3@11.10.0_db0@0.3.2_67465efcc111ea496614afff966a4bf6/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/app/node_modules/.pnpm/nuxt@3.17.4_@parcel+watcher@2.5.1_@types+node@22.15.24_better-sqlite3@11.10.0_db0@0.3.2_67465efcc111ea496614afff966a4bf6/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}